import { useEffect, useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Card, Stack, Badge, Spinner, Row, Col } from 'react-bootstrap';
import api from '../../../../common/api.js';
import "./AnalyticsChart.css";

ChartJS.register(ArcElement, Tooltip, Legend);

const SEGMENTS = [
  { label: 'Active',  color: '#1D9E75' },
  { label: 'Blocked', color: '#eb1f18' },
];

const EMPTY_DATA  = [1];
const EMPTY_COLOR = ['#efefef'];

const ClientsChart = () => {
  const [counts,  setCounts]  = useState([0, 0]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/clients')
      .then(({ data }) => {setCounts([data.active_count ?? 0, data.blocked_count ?? 0]);})
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const total = counts.reduce((s, v) => s + v, 0);
  const isEmpty = total === 0;

  const chartData = {
    labels: isEmpty ? ['No data'] : SEGMENTS.map((s) => s.label),
    datasets: [
      {
        data: isEmpty ? EMPTY_DATA : counts,
        backgroundColor: isEmpty ? EMPTY_COLOR : SEGMENTS.map((s) => s.color),
        borderWidth: 0,
        hoverOffset: isEmpty ? 0 : 6,
        borderRadius: 4,
        spacing: isEmpty ? 0 : 3,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%',
    animation: { duration: 600, easing: 'easeInOutQuart' },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        backgroundColor: '#ffffff',
        titleColor: '#1a1a2e',
        bodyColor: '#666',
        borderColor: '#e8e8e8',
        borderWidth: 1,
        padding: 10,
        cornerRadius: 8
      }}};

  return (
    <Card className="cc-card">
      <Card.Header className="cc-header bg-white border-0 px-4 pt-4 pb-3">
        <Card.Title className="fw-bold mb-1 cc-title">Clients</Card.Title>
        <Card.Subtitle className="cc-subtitle">Distribution by status</Card.Subtitle>
      </Card.Header>
      <Card.Body className="px-4 pb-4 pt-4">
        <Stack direction="vertical" gap={4} className="align-items-center">
          <div className="cc-donut-wrapper">
            <Doughnut data={chartData} options={chartOptions} />
            <Stack direction="vertical" className="cc-center align-items-center justify-content-center">
              {loading ? <Spinner animation="border" size="sm" variant="secondary" /> : (
                <>
                  <span className="cc-total fw-bold">{total.toLocaleString()}</span>
                  <span className="text-muted cc-total-label">Total</span>
                </>
              )}
            </Stack>
          </div>
          <Row className="g-2 pt-5 w-100">
            {SEGMENTS.map(({ label, color }, i) => { const value = counts[i];
              return (
                <Col key={label} xs={6}>
                  <Stack direction="horizontal" gap={2} className="cc-legend-item rounded-3 px-3 py-2 align-items-center">
                    <Badge className="cc-dot p-0 rounded-circle flex-shrink-0" style={{ backgroundColor: color, width: 10, height: 10 }}/>
                    <Stack direction="horizontal" className="flex-grow-1 justify-content-between align-items-center">
                    <span className="fw-bold cc-legend-label">{label}</span>
                    <span className="fw-bold cc-legend-value">{value.toLocaleString()}</span>
                    </Stack>
                  </Stack>
                </Col>
              );})}
          </Row>
        </Stack>
      </Card.Body>
    </Card>
  );
};
export default ClientsChart;